function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChaseInverted = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_8328_1275)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0 28.1081L12.973 40H24.8649C25.4616 40 25.9459 39.5157 25.9459 38.9189V28.1081H0Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M28.1082 40L40 27.027V15.1351C40 14.5384 39.5157 14.054 38.919 14.054H28.1082V40Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40 11.8919L27.0271 0H15.1352C14.5384 0 14.0541 0.484324 14.0541 1.08108V11.8919H40Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.8919 0L0 12.973V24.8649C0 25.4616 0.484324 25.9459 1.08108 25.9459H11.8919V0Z",
      fill: "white"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_8328_1275",
      children: /*#__PURE__*/_jsx("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}));
ChaseInverted.displayName = 'ChaseInverted';
//# sourceMappingURL=ChaseInverted.js.map